import { memo, MouseEvent } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { StarIcon as StarIconStroke } from "@hugeicons-pro/core-stroke-rounded";
import { StarIcon as StarIconSolid } from "@hugeicons-pro/core-solid-rounded";
import { cx } from "shared/utils";
import { useStarLead } from "shared/app/LeadsTableView/hooks/useStarLead";

interface StarCellProps {
  leadId: number;
  starred: boolean;
}

export const StarCell = memo(function StarCell({
  leadId,
  starred
}: StarCellProps) {
  const { mutate, isPending } = useStarLead();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isPending) return;
    mutate({ lead_id: leadId, starred: !starred });
  };

  return (
    <div className="flex items-center justify-center w-full h-full">
      <button
        type="button"
        aria-label={starred ? "Unstar lead" : "Star lead"}
        aria-pressed={starred}
        onClick={handleClick}
        className={cx(
          "flex items-center justify-center w-8 h-8 rounded-md transition-colors",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
          starred
            ? "text-primary-500 hover:text-primary-600"
            : "text-content-300 hover:text-content-500"
        )}
      >
        <HugeiconsIcon
          icon={starred ? StarIconSolid : StarIconStroke}
          size={20}
          className="shrink-0"
          strokeWidth={1.5}
        />
      </button>
    </div>
  );
});
